export default "__VITE_ASSET__a4605f26__"